// src/pages/shop/ShopWaiterHistory.jsx
//
// История закрытых заказов кафе. Список за последние закрытия (свои — у сотрудника,
// все — у владельца/админа). Тап по заказу → карточка (только просмотр).

import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { cafeOrders as cafeApi } from '../../api';
import { useToast } from '../../hooks/useToast';
import { useMyCurrency } from '../../hooks/useMyShop';
import { useAuth } from '../../hooks/useAuth';
import { formatMoney } from '../../data/currencies';
import { errorMessage } from '../../utils/errorMessage';
import Icon from '../../components/Icon';
import BottomNav from '../../components/BottomNav';
import { useShopNav } from './ShopHome';

function fmtDate(iso) {
  if (!iso) return '';
  try {
    return new Date(iso).toLocaleString('ru-RU', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' });
  } catch { return ''; }
}

export default function ShopWaiterHistory() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { show, ToastView } = useToast();
  const currency = useMyCurrency();
  const { isOwner, can } = useAuth();
  const navItems = useShopNav();
  const privileged = isOwner || can('all');

  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try { const r = await cafeApi.list('closed'); setOrders(r.items || []); }
      catch (e) { show(errorMessage(e, t), 'error'); }
      finally { setLoading(false); }
    })();
  }, []); // eslint-disable-line

  return (
    <div className="page" style={{ paddingBottom: 90 }}>
      {ToastView}
      <div className="page-header">
        <button className="back-btn" onClick={() => navigate('/waiter')}><Icon name="chevronLeft" size={18} /></button>
        <h1 className="page-title">{t('waiter.history')}</h1>
      </div>

      <div style={{ padding: '0 20px' }}>
        {loading ? (
          <div style={{ padding: 40, textAlign: 'center' }}><div className="spinner" /></div>
        ) : orders.length === 0 ? (
          <div style={{ padding: 32, textAlign: 'center', color: 'var(--fg-faint)', fontSize: 13 }}>{t('waiter.noHistory')}</div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            {orders.map(o => (
              <button
                key={o.id} onClick={() => navigate(`/waiter/order/${o.id}`)}
                className="card" style={{ padding: '12px 14px', textAlign: 'left', width: '100%', border: '1px solid var(--border)' }}
              >
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 4 }}>
                  <span style={{ fontSize: 14, fontWeight: 800 }}>{t('waiter.tableShort')} {o.tableLabel} · №{o.number}</span>
                  <span style={{ fontSize: 14, fontWeight: 700, fontVariantNumeric: 'tabular-nums' }}>{formatMoney(o.total, currency)}</span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <span style={{ fontSize: 12, color: 'var(--fg-muted)' }}>{fmtDate(o.closedAt || o.createdAt)}</span>
                  {privileged && o.createdByName && <span style={{ fontSize: 12, color: 'var(--fg-faint)' }}>{o.createdByName}</span>}
                </div>
              </button>
            ))}
          </div>
        )}
      </div>

      <BottomNav items={navItems} />
    </div>
  );
}
